import { Tooltip, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { req } from "../shared/api/client.js";

// Baked at build time by vite `define` (from package.json → mirrored from the repo-root VERSION).
const FRONTEND = __APP_VERSION__;

/** The backend's version from the public /health (SemVer). Only changes on a deploy → long stale time,
 *  no retry (a version tag must never spin a failing request). */
function useApiVersion() {
  return useQuery({
    queryKey: ["api-health-version"],
    queryFn: () => req<{ version?: string; service?: string }>("/health"),
    staleTime: 10 * 60_000,
    retry: false,
  });
}

/** Dimmed monospace version tag pinned to the bottom of the sidebar — the PLATFORM (backend + admin) SemVer,
 *  a separate axis from the mobile app's version. Shows the admin (frontend) build; if the backend reports a
 *  different version (a cached SPA vs a freshly-deployed API), it appends `· api x.y.z` so the drift shows. */
export function VersionFooter() {
  const api = useApiVersion().data?.version;
  const drift = !!api && api !== FRONTEND;
  return (
    <div style={{ marginTop: "auto", padding: "10px 16px", borderTop: "1px solid rgba(128,128,128,0.18)" }}>
      <Tooltip title={`admin ${FRONTEND}${api ? ` · api ${api}` : ""}`} placement="topLeft">
        <Typography.Text type="secondary" style={{ fontFamily: "monospace", fontSize: 11.5, opacity: 0.75 }}>
          v{FRONTEND}{drift ? ` · api ${api}` : ""}
        </Typography.Text>
      </Tooltip>
    </div>
  );
}
